!function() {
  class t extends HTMLElement {
    constructor() {
      if (super(), this.titleHolder = this.querySelector("[data-title-holder]"), !this.titleHolder) return;
      this.swatchLinks = this.querySelectorAll("[data-swatch]"), this.originalTitle = this.titleHolder.textContent.trim();
      const t = this.originalTitle.indexOf(":");
      this.baseTitle = -1 !== t ? this.originalTitle.substring(0, t + 1) + " " : "", this.onMouseOver = this.onMouseOver.bind(this), 
      this.onMouseOut = this.onMouseOut.bind(this);
    }
    connectedCallback() {
      this.titleHolder && this.swatchLinks.forEach(t => {
        t.addEventListener("mouseover", this.onMouseOver), t.addEventListener("mouseout", this.onMouseOut);
      });
    }
    disconnectedCallback() {
      this.titleHolder && this.swatchLinks.forEach(t => {
        t.removeEventListener("mouseover", this.onMouseOver), t.removeEventListener("mouseout", this.onMouseOut);
      });
    }
    onMouseOver(t) {
      const e = t.currentTarget.dataset.title;
      this.titleHolder.textContent = `${this.baseTitle}${e}`;
    }
    onMouseOut() {
      this.titleHolder.textContent = this.originalTitle;
    }
  }
  customElements.get("product-swatches") || customElements.define("product-swatches", t);
}();